var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_228_4362)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.5 3.23682H2.5C2.36739 3.23682 2.24021 3.28949 2.14645 3.38326C2.05268 3.47703 2 3.60421 2 3.73682V13.7368L4 12.7368L6 13.7368L8 12.7368L10 13.7368L12 12.7368L14 13.7368V3.73682C14 3.60421 13.9473 3.47703 13.8536 3.38326C13.7598 3.28949 13.6326 3.23682 13.5 3.23682ZM7 10.2368H4V6.23682H7V10.2368Z",
    fill: "#4B4AD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 13.7368V3.73682C2 3.60421 2.05268 3.47703 2.14645 3.38326C2.24021 3.28949 2.36739 3.23682 2.5 3.23682H13.5C13.6326 3.23682 13.7598 3.28949 13.8536 3.38326C13.9473 3.47703 14 3.60421 14 3.73682V13.7368L12 12.7368L10 13.7368L8 12.7368L6 13.7368L4 12.7368L2 13.7368Z",
    stroke: "#4B4AD5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 7.23682H12",
    stroke: "#4B4AD5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9.23682H12",
    stroke: "#4B4AD5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6.23682H4V10.2368H7V6.23682Z",
    stroke: "#4B4AD5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_228_4362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsPurple);
export default __webpack_public_path__ + "static/media/news-purple.371b4ddc667c2fd0dbac7aaa3be09bdb.svg";
export { ForwardRef as ReactComponent };